/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Pick1Inputs */

const vi_sitesettings_icon_pick1 = /** @type {(inputs: Sitesettings_Icon_Pick1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn biểu tượng`)
};

/**

* @param {Sitesettings_Icon_Pick1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_pick1 = /** @type {((inputs?: Sitesettings_Icon_Pick1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Pick1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_pick1(inputs)
});
export { sitesettings_icon_pick1 as "siteSettings_icon_pick" }